import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login/login' //登录
import index from '@/components/index' //主首页
import main from '@/components/index/main' //首页
import txt from '@/components/index/txt' //首页
import introduction from '@/components/index/introduction' //产品介绍
import personalcenter from '@/components/index/personalcenter' //个人中心
// import companyDetail from '@/components/index/TemplateCompany' //企业详情

Vue.use(Router)
const router = new Router({
  mode: 'history', //去掉url中的#
  routes: [{
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/txt',
      name: 'txt',
      component: txt,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        requiresAuth: true
      },
      redirect: '/main',
      children: [{
          path: '/main',
          name: 'main',
          component: main
        },
        {
          path: '/introduction',
          name: 'introduction',
          component: introduction
        },
        {
          path: '/personalcenter',
          name: 'personalcenter',
          component: personalcenter
        }
        // ,
        // {
        //   path: '/companyDetail',
        //   name: 'companyDetail',
        //   component: companyDetail
        // }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
});
// router.beforeEach((to, from, next) => {
//   document.body.scrollTop = 0;
//   next()
//   });
// router.matcher = new Router({
//   routes: newRoutes
// }).matche

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 导航守卫
//使用 router.beforeEach 注册一个全局前置守卫
// router.beforeEach((to, from, next) => {
//   console.log(to)
//   console.log(from)
//   if (to.name == null) {
//     console.log('导航守卫')
//     next('/menu');
//   }
//   else {
//     console.log('导航守卫2')
//     next();
//   }
// });


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js